import './HintWindow.css';
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import HintModal from './component/HintModal';
import { vector } from '../../_config/layers/';
import { Button } from 'primereact/button';

function HintWindow(props) {
  const { t } = useTranslation();
  const restoreElement = useRef();
  const [active, setActive] = useState(false);

  const handleClick = () => {
    setActive(prev => !prev);
    vector.getSource().clear();
  };

  return (
    <div id="HintWindow" className="HintWindow">
      <Button
        className="HorizontalButton"
        type="button"
        alt={t('hintWindow.tooltip')}
        title={t('hintWindow.tooltip')}
        onClick={handleClick}
        ref={restoreElement}
        icon="pi pi-question-circle"
      >
       
      </Button>

      <HintModal active={active} callback={setActive} />
    </div>
  );
}

export default HintWindow;
